import ChangePassword from './changePassword/ChangePassword'

const accountSetting = () => {
  return (
    <div>
      <ChangePassword/>
    </div>
  )
}

export default accountSetting

